export default function handleH2Size(isH2AlternativeSize, styles) {
  if (isH2AlternativeSize) {
    return styles._alternative;
  } else return "";
}
